
<div class="site-panel w-100" >
    <v-form ref="form">
        <v-row class="no-frame">
            <v-col class="main-first-col modal-tab">
                <f-title class="mt-0" title="Allgemeine Daten" />
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-select
                            v-model       = "type"
                            label         = "Anlagenart"
                            module        = "msd"
                            type          = "siteType"
                            :readonly     = "readonly"
                            :hide-details = "true"
                            class         = "mb-2"
                            @input        = "onType"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-enum-select
                            v-model = "spec.typeOfDrive"
                            label   = "Antriebsart"
                            module  = "msd"
                            type    = "siteTypeOfDrive"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-autocomplete
                            v-model = "spec.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-year-select
                            v-model="spec.yearOfConstruction"
                            label  = "Baujahr"
                            :from   = "1900"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-autocomplete
                            v-model = "spec.rebuilder"
                            label   = "Umbaufirma"
                            module  = "msd"
                            type    = "manufacturer"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-year-select
                            v-model="spec.yearOfRebuild"
                            label  = "Umbaujahr"
                            :from   = "1900"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            label="Typenbezeichnung"
                            v-model="spec.model"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-enum-select
                            v-model = "spec.typeOfUse"
                            label   = "Nutzungsart"
                            module  = "msd"
                            type    = "siteTypeOfUse"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <f-enum-select
                            v-model = "spec.buildingType"
                            label   = "Gebäudetyp"
                            module  = "msd"
                            type    = "siteBuildingType"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <f-enum-select
                            v-model = "spec.installationRegulation"
                            label   = "Errichtungsnorm"
                            module  = "msd"
                            type    = "siteInstallationRegulation"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            label="Prüfbuch"
                            v-model="spec.storageAuditBook"
                            :readonly  = "readonly"
                            :hide-details = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-text-field
                            label="Schlüsseltressor"
                            v-model="spec.keysave"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "spec.locationMr"
                            label   = "Lange Maschinenraum"
                            module  = "msd"
                            type    = "siteLocationMr"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <v-text-field
                            label="Belüftung Maschinenraum"
                            v-model="spec.ventilationMr"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Technische Daten" />
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <v-text-field
                            label="Haltestellen"
                            v-model="spec.stops"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Zugangsstellen"
                            v-model="spec.entrypoints"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <v-text-field
                            label="Tragfähigkeit in kg"
                            v-model="spec.loadCapacityKg"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            type         = "number"
                            class        = "mb-2"
                            @keypress="checkInteger"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Tragfähigkeit in Personen"
                            v-model="spec.loadCapacityPeople"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            type         = "number"
                            class        = "mb-2"
                            @keypress="checkInteger"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-2">
                        <v-text-field
                            label        = "Geschwindigkeit"
                            v-model      = "spec.speed"
                            type         = "number"
                            class        = "inputNumber mb-2"
                            :hide-details = "true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                    <v-col class="no-frame col-6 pl-2">
                        <v-text-field
                            label        = "Förderhöhe"
                            v-model      = "spec.liftingheight"
                            type         = "number"
                            class        = "inputNumber mb-2"
                            :hide-details = "true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame mt-6">
                    <v-col class="no-frame col-6 pr-3">
                        <v-checkbox
                            v-model="spec.durchladung"
                            label="Durchladung"
                            :ripple="false"
                            class="mt-0"
                            :hide-details="true"
                            :readonly  = "readonly"
                            dense
                        />
                        <v-checkbox
                            v-model="spec.trenntuer"
                            label="Trenntür"
                            class="mt-0"
                            :ripple="false"
                            :hide-details="true"
                            :readonly  = "readonly"
                            dense
                        />
                        <v-checkbox
                            v-model="spec.uebereckausladung"
                            label="Übereckausladung"
                            :ripple="false"
                            class="mt-0"
                            :hide-details="true"
                            :readonly  = "readonly"
                            dense
                        />
                    </v-col>
                    <v-col class="no-frame col-6">
                        <v-checkbox
                            v-model="spec.rucksack"
                            label="Rucksackaufhängung"
                            class="mt-0"
                            :ripple="false"
                            :hide-details="true"
                            :readonly  = "readonly"
                            dense
                        />
                        <v-checkbox
                            v-model="spec.rollenraum"
                            label="Rollenraum"
                            class="mt-0"
                            :ripple="false"
                            :hide-details="true"
                            :readonly  = "readonly"
                            dense
                        />
                    </v-col>
                </v-row>

                <c-v-spacer />
            </v-col>

            <v-col class="main-middlle-col modal-tab">
                <f-title title="Gruppe" class="mt-0" />
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-select
                            v-model = "spec.typeOfGroup"
                            label   = "Art"
                            module  = "msd"
                            type    = "siteTypeOfGroup"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <f-enum-select
                            v-model = "spec.groupPosition"
                            label   = "Position der Gruppe"
                            module  = "msd"
                            type    = "siteGroupPosition"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>

                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-select
                            v-model = "spec.positionInGroup"
                            label   = "Pos. in der Gruppe"
                            module  = "msd"
                            type    = "sitePositionInGroup"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Motor" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.engine.type"
                            label        = "Motor/Getriebeart"
                            module       = "msd"
                            type         = "siteTzbEngineType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                           class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-autocomplete
                            v-model = "tzb.engine.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Typ"
                            v-model="tzb.engine.model"
                            :hide-details="true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Steuerung" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.automatic.type"
                            label        = "Steuerungsart"
                            module       = "msd"
                            type         = "siteTzbAutomaticType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-autocomplete
                            v-model = "tzb.automatic.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Typ"
                            v-model="tzb.automatic.model"
                            :hide-details="true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "spec.collectiveControlType"
                            label        = "Sammelsteuerung"
                            module       = "msd"
                            type         = "siteCollectiveControlType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>


                <f-title class="mt-5" title="Regelung" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.control.type"
                            label        = "Regelungsart"
                            module       = "msd"
                            type         = "siteTzbControlType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-autocomplete
                            v-model = "tzb.control.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Typ"
                            v-model="tzb.control.model"
                            :hide-details="true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Gegengewicht" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <v-checkbox
                            v-model="spec.zuganker"
                            label="Zuganker"
                            class="mt-0"
                            :ripple="false"
                            :hide-details="true"
                            :readonly  = "readonly"
                            dense
                        />
                    </v-col>
                </v-row>

                <c-v-spacer />
            </v-col>

            <v-col class="main-middlle-col modal-tab">
                <f-title class="mt-0" title="Tragmittel" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "spec.carrierType"
                            label   = "Art der Tragmittel"
                            module  = "msd"
                            type    = "siteCarrierType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <v-text-field
                            label="Durchmesser der Tragmittel"
                            v-model="spec.durchmesserTragmittel"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-col class="no-frame pr-2">
                            <v-text-field
                                label="Anzahl Tragmittel"
                                v-model="spec.anzahlTragmittel"
                                :hide-details = "true"
                                type         = "number"
                                :readonly  = "readonly"
                                class        = "mb-2"
                            />
                        </v-col>
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Fangvorrichtung" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.saftyCatch.type"
                            label        = "Fangvorrichtungsart"
                            module       = "msd"
                            type         = "siteTzbSaftyCatchType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-autocomplete
                            v-model = "tzb.saftyCatch.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Typ"
                            v-model="tzb.saftyCatch.model"
                            :hide-details="true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Geschwindigkeitsbegrenzer" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.speedLimiter.type"
                            label        = "GB-Art"
                            module       = "msd"
                            type         = "siteTzbSpeedlimiterType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-autocomplete
                            v-model = "tzb.speedLimiter.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Typ"
                            v-model="tzb.speedLimiter.model"
                            :hide-details="true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "tzb.speedLimiter.kopierung"
                            label   = "Kopierung"
                            module  = "msd"
                            type    = "siteTzbKopierungType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Notrufleitsystem" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.emcSystem.type"
                            label        = "NRL-Art"
                            module       = "msd"
                            type         = "siteTzbEmcSystemType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-autocomplete
                            v-model = "tzb.emcSystem.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Typ"
                            v-model="tzb.emcSystem.model"
                            :hide-details="true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <v-text-field
                            label="Telefonnummer"
                            v-model="tzb.emcSystem.phone"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>

                <c-v-spacer />
            </v-col>

            <v-col class="main-last-col modal-tab">
                <f-title class="mt-0" title="Schachttür" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.liftShaftDoor.type"
                            label        = "Schachttürart"
                            module       = "msd"
                            type         = "siteTzbLiftShaftDoorType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                            :clearable = "true"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-autocomplete
                            v-model = "tzb.liftShaftDoor.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                            :clearable = "true"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Typ"
                            v-model="tzb.liftShaftDoor.model"
                            hide-details="true"
                            :readonly  = "readonly"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Fahrkorb" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "spec.typeOfSuspension"
                            label   = "Aufhängung"
                            module  = "msd"
                            type    = "siteTypeOfSuspension"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "tzb.car.wall"
                            label   = "Wandmaterial"
                            module  = "msd"
                            type    = "siteTzbCarWallType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "tzb.car.floor"
                            label   = "Boden"
                            module  = "msd"
                            type    = "siteTzbCarFloorType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "tzb.car.ceiling"
                            label   = "Deckenmaterial"
                            module  = "msd"
                            type    = "siteTzbCarCeilingType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "tzb.car.lighting"
                            label   = "Beleuchtung"
                            module  = "msd"
                            type    = "siteTzbCarLightingType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model = "tzb.car.mirror"
                            label   = "Spiegel"
                            module  = "msd"
                            type    = "siteTzbCarMirrorType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            :clearable = "true"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>

                <f-title class="mt-5" title="Fahrkorbtür" />
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.doorDrive.doorType"
                            label        = "Türart"
                            module       = "msd"
                            type         = "siteTzbCarDoorType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame">
                        <f-enum-select
                            v-model      = "tzb.doorDrive.type"
                            label        = "Türantriebsart"
                            module       = "msd"
                            type         = "siteTzbDoorDriveType"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <f-enum-autocomplete
                            v-model = "tzb.doorDrive.manufacturer"
                            label   = "Hersteller"
                            module  = "msd"
                            type    = "manufacturer"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Typ"
                            v-model="tzb.doorDrive.model"
                            hide-details="true"
                        />
                    </v-col>
                </v-row>
                <v-row class="no-frame">
                    <v-col class="no-frame pr-2">
                        <v-text-field
                            label="Türbreite (in mm)"
                            v-model="spec.doorwidth"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            type         = "number"
                            class        = "mb-2"
                        />
                    </v-col>
                    <v-col class="no-frame pl-2">
                        <v-text-field
                            label="Türhöhe (in m)"
                            v-model="spec.doorheight"
                            :hide-details = "true"
                            :readonly  = "readonly"
                            type         = "number"
                            class        = "mb-2"
                        />
                    </v-col>
                </v-row>
                <c-v-spacer />
            </v-col>
        </v-row>
    </v-form>
</div>
